<template>
    <div class="content">
        <h2>重大案件集体讨论
            <el-button type="warning" size="medium" @click="provinceData" style="float:right;">省案件信息同步</el-button>
        </h2>
        <el-form :model="form" ref="form" :rules="rules" label-width="110px">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="时间:"  required>
                        <el-form-item prop="taolun_rq1" style="width:230px; float:left;">
                            <el-date-picker size="small"
                                v-model="form.taolun_rq1"
                                type="date"
                                placeholder="选择日期" value-format="yyyy-MM-dd">
                            </el-date-picker>&nbsp;
                        </el-form-item>
                        <el-form-item prop="taolun_rq2" style="width:145px; float:left;">
                        <el-time-picker size="small" style="width:120px;"
                            placeholder="起始时间"
                            v-model="form.taolun_rq2">
                        </el-time-picker>&nbsp;至&nbsp;
                    </el-form-item>
                        <el-form-item prop="taolun_rq3" style="width:120px; float:left;">
                        <el-time-picker size="small" style="width:120px;"
                            placeholder="结束时间"
                            v-model="form.taolun_rq3">
                        </el-time-picker>
                        </el-form-item>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="地点:" prop="taolun_didian">
                        <el-input v-model="form.taolun_didian" ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="讨论原因：" prop="taolunYuanyin">
                        <el-input v-model="form.taolunYuanyin" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-col :span="7">
                    <el-form-item label="主持人：" prop="zhuchiren" >
                        <el-select v-model="form.zhuchiren" placeholder="请选择" size="small" @change="getZw2(1)">
                            <el-option
                                v-for="(dict,index) in userOptions2"
                                :key="index"
                                :label="dict.xm"
                                :value="dict.xm"
                                ></el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                    <el-col :span="17">
                    <el-form-item label="职务：" prop="taolun_zhiwu">
                        <el-input v-model="form.taolun_zhiwu" disabled ></el-input>
                    </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-col :span="7">
                    <el-form-item label="记录人：" prop="jiluren" >
                        <el-select v-model="form.jiluren" placeholder="请选择" size="small" @change="getZw2(2)">
                            <el-option
                                v-for="(dict,index) in userOptions2"
                                :key="index"
                                :label="dict.xm"
                                :value="dict.xm"
                                ></el-option>
                        </el-select>&nbsp;
                        
                    </el-form-item>
                </el-col>
                    <el-col :span="17">
                    <el-form-item label="职务：" prop="zhiwu2">
                        <el-input v-model="form.zhiwu2" disabled ></el-input>
                    </el-form-item>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-col :span="7">
                        <el-form-item label="参会人员：" prop="chry" >
                            <el-select v-model="form.chry" placeholder="请选择" size="small">
                                <el-option
                                    v-for="(dict,index) in userOptions2"
                                    :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                    ></el-option>
                            </el-select>
                            <el-button type="primary" @click="addChry">添加</el-button>
                            <el-button type="primary" @click="delChry">清空</el-button>
                        </el-form-item>    
                    </el-col>
                    <el-col :span="17">
                        <el-input v-model="form.taolun_canhuirenyuan" type="textarea" :rows=4 style="width:calc(100% - 40px); margin-left:40px;"></el-input>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-col :span="7">
                        <el-form-item label="列席人员：" prop="lxry" >
                            <el-select v-model="form.lxry" placeholder="请选择" size="small">
                                <el-option
                                    v-for="(dict,index) in userOptions"
                                    :key="index"
                                    :label="dict.xm"
                                    :value="dict.xm"
                                    ></el-option>
                            </el-select>
                            <el-button type="primary" @click="addLxry">添加</el-button>
                            <el-button type="primary" @click="delLxry">清空</el-button>
                        </el-form-item>
                    </el-col>
                    <el-col :span="17">
                        <el-input v-model="form.taolun_liexierenyuan" type="textarea" :rows=4 style="width:calc(100% - 40px); margin-left:40px;"></el-input>
                    </el-col>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="案件情况：" prop="jtAjqingkuang">
                        <el-input v-model="form.jtAjqingkuang" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="承办机构意见：" prop="jtYijian">
                        <el-input v-model="form.jtYijian" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="主持人意见：" prop="zhuchirenYijian">
                        <el-input v-model="form.zhuchirenYijian" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="24">
                    <el-form-item label="结论性意见：" prop="jielunxingYijian">
                        <el-input v-model="form.jielunxingYijian" type="textarea" :rows=4></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item>
                        <el-button type="primary" @click="submit('form')">生成重大案件集体讨论</el-button>
                        <el-button type="warning" v-if="isWs" @click="show()">预览</el-button>
                        <el-button type="danger" v-if="isWs" @click="edit()">编辑</el-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <div v-show="loading" class="loading">
            <i class="el-icon-loading"></i>
            <p>文书生成中...</p>
        </div>

        <el-dialog title="重大案件集体讨论" :visible.sync="dialogWordVisible"  width="600px" append-to-body :close-on-click-modal="false">
            <div v-loading="loadingWord">
                <p style="color: #ff0000;font-weight:bold;margin-bottom:20px;">* Word编辑后，请点击 "<i class="el-icon-refresh"></i>重新生成" 按钮，生成新的文书！！！</p>
                <p style="margin-bottom:20px;">
                    <el-button size="small" type="danger" @click="editWord()" icon="el-icon-edit">Word编辑</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="primary" @click="resetWord()" icon="el-icon-refresh">重新生成</el-button>&nbsp;&nbsp;
                    <el-button size="small" type="warning" @click="showWord()" icon="el-icon-view">预 览</el-button>
                </p>
                <div slot="footer" class="dialog-footer" style="text-align:right;">
                    <el-button @click="dialogWordVisible = false">取 消</el-button>   
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
    name: "Layout",
    props:['code','pcId'],
    data() {
        return {
            loading:false,
            xm:'',
            dm:'',
            cmid:'',
            shi:'',
            xianqu:'',
            gzbm:'',
            gzzw:'',
            form:{
            },
            rules:{
                taolun_rq1:[
                    { required: true, message: '集体讨论时间不能为空', trigger: ['change','blur'] }
                ],
                taolun_rq2:[
                    { required: true, message: '集体讨论时间不能为空', trigger: ['change','blur'] }
                ],
                taolun_rq3:[
                    { required: true, message: '集体讨论时间不能为空', trigger: ['change','blur'] }
                ],
            },
            isWs:false,
            userOptions:[],
            userOptions2:[],

            dialogWordVisible:false,
            loadingWord:false,
            wsPdf:'',
            docurl:'',
            zfXX:[]
        }
    },
    components: {
    },
    computed: {
    },
    created() {
        console.log(this.code)
    },
    async mounted() {
        let user = JSON.parse(sessionStorage.getItem("userdata"));
        this.xm = user.xm
        this.dm = user.dm
        this.cmid = user.c_mid
        this.shi = user.shi
        this.xianqu = user.xianqu
        this.gzbm = user.gzbm
        this.gzzw = user.gzzw
        let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdr1&c_mid=${this.cmid}`)
        if(data.data){
            this.userOptions = data.data
        }
        let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getJdyByWjw&c_mid=${this.cmid}`)
        if(data2.data){
            this.userOptions2 = data2.data
        }

        this.getList()
    },
    methods: {
        async getList(){
            this.isWs = false
            this.getZfxx()
            this.getwsNr()
            //判断文书是否存在
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getExistWenshu&id=${this.pcId}&fileName=${escape('集体讨论笔录')}&xcblFlag=`)
            if(data.data){
                if(data.data == '1'){
                    //有
                    this.isWs = true
                    
                }
                
            }
        },
        async getwsNr(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getjtllshuju&pcId=${this.pcId}&c_mid=${this.cmid}`)
            console.log(data)
            if(data.data){
                let obj = data.data
                this.$set(this.form,'jielunxingYijian',obj.jielunxingYijian)
                this.$set(this.form,'jiluren',obj.jiluren)
                this.$set(this.form,'jtAjqingkuang',obj.jtAjqingkuang)
                this.$set(this.form,'jtYijian',obj.jtYijian)
                this.$set(this.form,'taolunYuanyin',obj.taolunYuanyin)
                this.$set(this.form,'taolun_rq1',obj.taolun_rq1)
                this.$set(this.form,'taolun_rq2',obj.taolun_rq1+' '+obj.taolun_rq2)
                this.$set(this.form,'taolun_rq3',obj.taolun_rq1+' '+obj.taolun_rq3)
                this.$set(this.form,'taolun_zhiwu',obj.taolun_zhiwu)
                this.$set(this.form,'zhuchiren',obj.zhuchiren)
                this.$set(this.form,'zhuchirenYijian',obj.zhuchirenYijian)
                this.$set(this.form,'jtYijian',obj.jtYijian)
                this.$set(this.form,'zhiwu2',obj.zhiwu2)
                if(obj.taolun_didian){
                    this.$set(this.form,'taolun_didian',obj.taolun_didian)
                }else{
                    let data2 = await this.$axios.get(`${this.Global._baseUrl2}?act=getjuaddress&c_mid=${this.cmid}`)
                    if(data2.data){
                        console.log(data2.data)
                        if(data2.data.length > 0){
                            this.$set(this.form,'taolun_didian',data2.data[0].ju_address)
                        }
                    }
                }
                console.log(typeof(obj.taolun_canhuirenyuan),typeof(obj.taolun_liexierenyuan))
                let tt = obj.taolun_canhuirenyuan.indexOf(',') != -1?obj.taolun_canhuirenyuan.replace(/,/g, '\n'):obj.taolun_canhuirenyuan;
                this.$set(this.form,'taolun_canhuirenyuan',tt)
                
                let tt2 = obj.taolun_liexierenyuan.indexOf(',') != -1?obj.taolun_liexierenyuan.replace(/,/g, '\n'):obj.taolun_liexierenyuan;
                this.$set(this.form,'taolun_liexierenyuan',tt2)
                
            }
        },
        async getZfxx(){
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getZfxxInfo&id=${this.pcId}`)
            console.log(data)
            this.wsUrl = ''
            this.docurl = ''
            this.wsPdf = ''
            this.zfXX = []
            if(data.data){
                this.zfXX = data.data
                this.wsUrl = 'mid='+data.data[0].dwmc_id+'&lsh='+data.data[0].lsh+'&wsnameEw=jititaolunbilu&sjs='+new Date().getTime()
                let nm = 'jititaolunbilu'
                this.docurl = 'https://dapc.scqwszfd.cn:9080/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/'+nm+'.docx'
                this.wsPdf = 'https://dapc1.scqwszfd.cn:8123/zfjl/'+data.data[0].dwmc_id+'/'+data.data[0].lsh+'/tupian/'+nm+'.pdf?timestrap='+new Date().getTime()
                  
            }
        },
        getZw(val){
            console.log(val)
        },
        getZw2(val){
            if(val == 1){
                let index = this.userOptions2.findIndex(item => {
                    return item.xm == this.form.zhuchiren
                })
                console.log(index)
                this.$set(this.form,'taolun_zhiwu',this.userOptions2[index].zw)
            }else{
                let index = this.userOptions2.findIndex(item => {
                    return item.xm == this.form.jiluren
                })
                console.log(index)
                this.$set(this.form,'zhiwu2',this.userOptions2[index].zw)
            }
            console.log(val)
        },
        addChry(){
            let index = this.userOptions2.findIndex(item => {
                return item.xm == this.form.chry
            })
            // this.form.chryAllList.push(this.userOptions2[index])
            let  ss = ''
            console.log(this.form.taolun_canhuirenyuan.charAt(this.form.taolun_canhuirenyuan.length - 1).includes('↵'))
            if(this.form.taolun_canhuirenyuan){
                if(this.form.taolun_canhuirenyuan.charAt(this.form.taolun_canhuirenyuan.length - 1) === '\n'){
                    ss = this.form.taolun_canhuirenyuan
                }else{
                    ss = this.form.taolun_canhuirenyuan + '\n'
                }
            }else{
                ss = ''
            }
            let xm = [...this.userOptions2[index].xm]
            console.log(xm.length)
            let kg = xm.length<3?(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')):(xm.length>3?(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')):(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')))
            let str = ss+this.userOptions2[index].xm+kg+this.userOptions2[index].zw
            console.log(str)
            this.$set(this.form,'taolun_canhuirenyuan',str)
        },
        delChry(){
            this.$set(this.form,'taolun_canhuirenyuan','')
        },
        addLxry(){
            let index = this.userOptions.findIndex(item => {
                return item.xm == this.form.lxry
            })
            let  ss = ''
            console.log(this.form.taolun_liexierenyuan.charAt(this.form.taolun_liexierenyuan.length - 1).includes('↵'))
            if(this.form.taolun_liexierenyuan){
                if(this.form.taolun_liexierenyuan.charAt(this.form.taolun_liexierenyuan.length - 1) === '\n'){
                    ss = this.form.taolun_liexierenyuan
                }else{
                    ss = this.form.taolun_liexierenyuan + '\n'
                }
            }else{
                ss = ''
            }
            // this.form.lxryAllList.push(this.userOptions[index])
            let xm = [...this.userOptions[index].xm]
            console.log(xm.length)
            let kg = xm.length<3?(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')):(xm.length>3?(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')):(decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')+decodeURIComponent('%20')))
            let str = ss+this.userOptions[index].xm+kg+this.userOptions[index].gzzw
            console.log(str)
            this.$set(this.form,'taolun_liexierenyuan',str)
        },
        delLxry(){
            this.$set(this.form,'taolun_liexierenyuan','')
        },
        submit(form){
            this.$refs[form].validate((valid) => {
                if (valid) {
                    let that = this
                    let canhuirenyuan = this.form.taolun_canhuirenyuan  //.replace(/\t/g, '      ');//\\\\n
                    let liexierenyuan = this.form.taolun_liexierenyuan  //.replace(/\t/g, '      ');
                    
                    console.log(this.form)
                    console.log(this.getDate(this.form.taolun_rq2,'yyyy-MM-dd hh:mm:ss'),this.getDate(this.form.taolun_rq3,'yyyy-MM-dd hh:mm:ss'))
                    let sj1 = this.getDate(this.form.taolun_rq1,'yyyy-MM-dd')+' '+this.getDate(this.form.taolun_rq2,'hh:mm')
                    let sj2 = this.getDate(this.form.taolun_rq1,'yyyy-MM-dd')+' '+this.getDate(this.form.taolun_rq3,'hh:mm')
                    console.log(sj1,sj2)
                    let nr = sj1 + '|' + sj2 + 
                    '|'+escape(this.form.taolun_didian)+'|'+escape(this.form.taolunYuanyin) + '|' + escape(this.form.zhuchiren) + '|' + 
                    escape(this.form.taolun_zhiwu) + '|' + escape(this.form.jiluren) + '|' + escape(this.form.zhiwu2) + '|' + 
                    escape(canhuirenyuan) + '|' + escape(liexierenyuan) + '|' + escape(this.form.jtAjqingkuang) + '|' + 
                    escape(this.form.jtYijian) + '|' + escape(this.form.zhuchirenYijian) + '|' + escape(this.form.jielunxingYijian)
                    console.log(nr)
                    this.loading = true
                    axios({
                        method: 'post',
                        url: `${this.Global._baseUrl2}`,
                        data: {
                            act: "makeWenshu",
                            id: `${this.pcId}`,
                            wsName:escape('集体讨论笔录'),
                            shuju: nr,
                            caozuoStatus:1,
                            isOldWenshu:'',
                            wupin:'',
                            gzbm:`${escape(this.gzbm)}`,
                            gzzw:`${escape(this.gzzw)}`,
                            xm:`${escape(this.xm)}`,
                            dm:`${this.dm}`,
                            shi:`${escape(this.shi)}`,
                            xianqu:`${escape(this.xianqu)}`,
                        },
                        transformRequest: [function (data) {
                            data = qs.stringify(data);
                            return data;
                        }],
                        headers: { 'Content-Type':'application/x-www-form-urlencoded; charset=UTF-8'}
                    }).then(res => {
                        this.loading = false
                        console.log(res)
                        if(res.data.code != -1){
                            console.log(res.data.code)
                            this.$message({
                                message: '保存成功',
                                type: 'success'
                            });
                            this.isWs = true
                            this.wsUrl = res.data.data.split('?')[1]
                            this.show()
                        }else{
                            if(res.data.data){
                                this.$message.error(res.data.data)
                            }else{
                                this.$message({
                                    message: '保存失败，请重新填写',
                                    type: 'error'
                                }); 
                            }
                        }
                    }).catch(res => {
                        this.loading = false
                    })
                }
            })
        },
        show(){
            if(this.wsUrl){
                let mid = this.wsUrl.split('&')[0].replace('mid=','')
                let lsh = this.wsUrl.split('&')[1].replace('lsh=','')
                let wsname = this.wsUrl.split('&')[2].replace('wsnameEw=','')
                let sjs = this.wsUrl.split('&')[3].replace('sjs=','')
                let url = this.$router.resolve({
                    path:'/pdf',
                    query:{
                        mid:mid,
                        lsh:lsh,
                        wsname:wsname,
                        sjs:sjs
                    }
                })
                window.open(url.href,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        edit(){
            this.dialogWordVisible = true
        },
        editWord(){
            if(this.docurl){
                let url = this.docurl
                console.log(url)
                POBrowser.openWindowModeless('https://office.bjklk.cn/bjclick-health/pageoffice/word2?docurl='+encodeURIComponent(url)+'&type=1&user_name=王若飞','width=1600px;height=1024px;');
            }else{
                this.$message.error('当前word文档地址不存在，请联系管理员！')
            }
        },
        showWord(){
            if(this.wsPdf){
                window.open(this.wsPdf,'_blank')
            }else{
                this.$message.error('暂未制作本文书，不能预览！')
            }
        },
        //省数据同步
        async provinceData(){
            // if(this.form1.zzdm){
            //     let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getJgdxDataSync&dwmc=${escape(this.form1.dwmc)}&mid=${this.dwId}&type=0&code=0&creditCode=${this.form1.zzdm}&isClose=0`)
            //     if(data.data){
            //         let valdata = data.data[0].valdata
            //         if(data.data[0].outs == '0'){
            //             this.$message.error('未查询到省系统有此单位！')
            //             this.open8 = true
            //         }else if(data.data[0].outs == '99'){
            //             this.$message.error('程序异常！请重新点击一次！')
            //         }
            //         if(valdata != '0'){
            //             let object = data.data[0].valdata[0].datas[0]
            //         }
            //     }else{
            //         this.$message.error('程序异常！请重新点击一次！')
            //     }
            // }else{
            //     this.$message.error('统一社会信用代码为空！请补全信息后再次点击基本信息比对！')
            // }
        },
        async resetWord(){
            this.loadingWord = true
            //重新生成文书
            // let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.dqWord.mid}&lsh=${this.dqWord.lsh}&filecode=${this.dqWord.wsname}&DaLsh=`)
            let wsname = 'jititaolunbilu.docx'
            let data = await this.$axios.get(`${this.Global._baseUrl2}?act=getwordpdfjpg&mid=${this.zfXX[0].dwmc_id}&lsh=${this.zfXX[0].lsh}&filecode=${wsname}&DaLsh=`)
            console.log(data)
            if(data.data){
                if(data.data.pdfUrl){
                    window.open(data.data.pdfUrl,'_blank')
                    this.wsPdf = data.data.pdfUrl
                }else{
                    this.$message.error('暂未获取到文书，请重试或者联系管理员！')
                }
                this.loadingWord = false
            }else{
                this.loadingWord = false
            }
        },
    }
}
</script>


<style scoped>
.content >>> .el-textarea.is-disabled .el-textarea__inner ,.content >>> .el-input.is-disabled .el-input__inner{ color: #333;}
.loading{ width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); position: fixed; top:0;left: 0;text-align: center;}
.loading i{    font-size: 80px;color: #fff;opacity: 1; margin-top: 38vh;}
.loading p{   font-size: 20px; color: #fff; opacity: 1; line-height: 50px;}
.content{padding-right: 40px;}
.content h2{ text-align: center; padding: 10px 0; letter-spacing: 2px; overflow: hidden;}
</style>